/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable max-lines-per-function */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { Card, Checkbox, Space, Dropdown, Typography, Button } from "antd";
import ProductImage from "./ProductImage";
import ProductTitle from "./ProductTitle";
import { MenuOutlined } from "@ant-design/icons";
import { IProductCard } from "interfaces/ClientInterface/IProduct";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import type { MenuProps } from "antd";
import {
  associateProduct,
  deleteProductService,
  deleteProductServiceFromArtifi,
  renameProductConfigurationNameService,
} from "api/services/product.api";
import { notificationController } from "components/Common/Notification/Notification";
import { DeleteProductsBody } from "interfaces/ApiInterface/IProductGroupList";
import RenameProductModal from "./RenameProductModal";
import DeleteProductModal from "./DeleteProductModal";
import { setSelectedProductRedux } from "store/slices/product.slice";
import ArtifiIntegration from "./ArtifiIntegration";
import { Artifisettings } from "api/IProduct";
import { useDispatch } from "react-redux";
import { useAppSelector } from "hooks/reduxHooks";
import { getLookupConfiguration } from "api/services/getLookupConfiguration.api";
import { setProductCustomizationDetails } from "store/slices/productCustomizationSlice";
import { setLookup } from "store/slices/lookup.slice";

const { Text } = Typography;

interface MyCollectionCardProps extends IProductCard {
  modifiedDate: string;
  onCheckboxChange: (product: any, isChecked: boolean) => void;
  getProductList: (groupName: string) => void;
  groupName: string;
  artifConfigurations: Artifisettings | undefined;
  designId: string;
  groupText: string;
  isChecked: boolean;
  refreshGroupNameFilterList: boolean;
  customisedProducts: any;
  setSelectedGroupName: (groupName: string) => void;
  setRefreshGroupNameFilterList: (refreshGroupNameFilterList: boolean) => void;
}

const MyCollectionCard: React.FC<MyCollectionCardProps> = ({
  modifiedDate,
  imageUrl,
  titleText,
  groupText,
  product,
  designId,
  onCheckboxChange,
  getProductList,
  groupName,
  artifConfigurations,
  isChecked,
  refreshGroupNameFilterList,
  setSelectedGroupName,
  setRefreshGroupNameFilterList,
  customisedProducts,
}: MyCollectionCardProps) => {
  const dispatch = useDispatch();
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState<boolean>(false);
  const [isRenameModalVisible, setIsRenameModalVisible] = useState<boolean>(false);
  const [renameProductName, setRenameProductName] = useState<string>(titleText);
  const [renameGroupName, setRenameGroupName] = useState<string>(groupText);
  const [showArtifi, setshowArtifi] = useState<boolean>(false);
  const [showArtifiToDuplicate, setshowArtifiToDuplicate] = useState<boolean>(false);
  const [configurationId, setConfigurationId] = useState<number>();
  const userDetails = useAppSelector((state: any) => state.user.user);
  const lockerDetails: any = useAppSelector((state) => state.landingPage.lockerPortalDetails);
  const leatherType = JSON.parse(product?.ProductCustomizationJson)?.leather;

  const viewEditLable = product?.DesignType === "Rawlings" ? "View" : "View/Edit";

  const handleCheckboxChange = (e: CheckboxChangeEvent): void => {
    ReactGA.event({
      category: "card_checkbox",
      action: "Card checkbox clicked",
      label: "Card checkbox clicked",
    });
    const { checked } = e.target;
    onCheckboxChange(product, checked);
  };

  const showRenameProductModal = (): void => {
    ReactGA.event({
      category: "show_rename_modal",
      action: "Rename design button clicked",
      label: "Rename design button clicked",
    });
    setRenameProductName(titleText);
    setRenameGroupName(groupText);
    setIsRenameModalVisible(true);
    setDropdownOpen(false);
  };

  const showDeleteProductModal = (): void => {
    ReactGA.event({
      category: "delete_product",
      action: "Delete design button click",
      label: "Delete design button click",
    });
    setIsDeleteModalVisible(true);
    setDropdownOpen(false);
  };

  const getCode = (code: string): string[] => {
    if (code === "Helmet") {
      return ["helmets", "rawlings"];
    }
    if (code === "RawlingsGlove") {
      return ["gloves", "rawlings"];
    }
    if (code === "EastonGlove") {
      return ["gloves", "easton"];
    }
    if (code === "EastonHelmet") {
      return ["helmets", "easton"];
    }
    if (code === "WoodBat") {
      return ["woodbats", "rawlings"];
    }
    return [];
  };

  const openConfigurationWindowDuplicate = async (
    [product, domain]: string[],
    customProduct: any
  ): Promise<void> => {
    const guid = JSON.parse(customProduct?.ProductCustomizationJson)?.guid;
    const configUrl = process.env.REACT_APP_THIRD_PARTY_CONFIGURATION;
    const openConfig = configUrl?.replace("<product>", product).replace("<domain>", domain);
    window.open(`${openConfig}/design/${customProduct?.DesignId}?guid=${guid}`, "_self");
  };

  const handleDuplicateProduct = async () => {
    const configurationId = product.DesignId;
    const isCustomizedProduct = customisedProducts.find(
      (item: any) => item?.DesignId === configurationId
    );
    setConfigurationId(configurationId);
    if (product && configurationId) {
      getLookupConfiguration(product?.SKU, configurationId)
        .then((response) => {
          if (response.status === 200 && response?.data && response?.data?.ProductName !== null) {
            localStorage.setItem("selectedProduct", product.ProductName);
            localStorage.setItem("SKU", product?.SKU);
            setDropdownOpen(false);
            if (isCustomizedProduct && isCustomizedProduct?.DesignType === "Artifi") {
              dispatch(setProductCustomizationDetails(response.data));
              dispatch(setSelectedProductRedux(response.data));
              dispatch(setLookup({ fromLookup: true } as any));
              setshowArtifiToDuplicate(true);
            } else if (isCustomizedProduct && isCustomizedProduct?.DesignType === "Rawlings") {
              associateProduct(
                lockerDetails?.lockerPortalDetails?.PortalId,
                lockerDetails?.lockerPortalDetails?.PublishCatalogId
              )
                .then((associatedProductsList: any) => {
                  if (
                    associatedProductsList &&
                    associatedProductsList?.data &&
                    associatedProductsList?.data?.PublishProducts
                  ) {
                    const configuratorProduct = associatedProductsList?.data?.PublishProducts.find(
                      (item: any) => item.SKU === isCustomizedProduct?.SKU
                    );

                    const attributes = configuratorProduct?.Attributes.filter(
                      (attribute: any) => attribute?.AttributeCode === "ConfigurationType"
                    );

                    const configuratorType = attributes[0]?.SelectValues[0]?.Code;
                    openConfigurationWindowDuplicate(
                      getCode(configuratorType),
                      isCustomizedProduct
                    );
                  }
                })
                .catch((error) => {
                  throw error;
                });
            }
          } else {
            const errorMessage = "This configuration does not exist.";
            notificationController.error({
              message: errorMessage,
            });
          }
        })
        .catch((error: any) => {
          throw error;
        });
    }
  };

  const openConfigurationWindow = async (
    [product, domain]: string[],
    designId: string
  ): Promise<void> => {
    const configUrl = process.env.REACT_APP_THIRD_PARTY_CONFIGURATION;
    const openConfig = configUrl?.replace("<product>", product).replace("<domain>", domain);
    window.open(`${openConfig}/review/${designId}`, "_self");
  };

  const viewOrEdit = async (): Promise<void> => {
    ReactGA.event({
      category: "view_or_edit_product",
      action: `${viewEditLable} button clicked`,
      label: `${viewEditLable} button clicked`,
    });
    if (product?.DesignType === "Artifi") {
      setshowArtifi(true);
      setDropdownOpen(false);
      dispatch(setSelectedProductRedux(product));
    } else if (product?.DesignType === "Rawlings") {
      associateProduct(
        lockerDetails?.lockerPortalDetails?.PortalId,
        lockerDetails?.lockerPortalDetails?.PublishCatalogId
      )
        .then((associatedProductsList: any) => {
          if (
            associatedProductsList &&
            associatedProductsList?.data &&
            associatedProductsList?.data?.PublishProducts
          ) {
            const isProduct = associatedProductsList?.data?.PublishProducts.find(
              (item: any) => item.SKU === product?.SKU
            );

            const configurationTypeObject = isProduct?.Attributes?.find(
              (attribute: { AttributeCode: string }) =>
                attribute.AttributeCode === "ConfigurationType"
            );

            const helmet = configurationTypeObject?.SelectValues?.find(
              (value: { Code: string }) => value.Code === "Helmet"
            );

            const rawlingsGlove = configurationTypeObject?.SelectValues?.find(
              (value: { Code: string }) => value.Code === "RawlingsGlove"
            );

            const eastonGlove = configurationTypeObject?.SelectValues?.find(
              (value: { Code: string }) => value.Code === "EastonGlove"
            );

            const eastonHelmet = configurationTypeObject?.SelectValues?.find(
              (value: { Code: string }) => value.Code === "EastonHelmet"
            );

            const woodBat = configurationTypeObject?.SelectValues?.find(
              (value: { Code: string }) => value.Code === "WoodBat"
            );

            if (helmet) openConfigurationWindow(getCode(helmet?.Code), product?.DesignId);
            if (rawlingsGlove)
              openConfigurationWindow(getCode(rawlingsGlove?.Code), product?.DesignId);
            if (eastonGlove) openConfigurationWindow(getCode(eastonGlove?.Code), product?.DesignId);
            if (eastonHelmet)
              openConfigurationWindow(getCode(eastonHelmet?.Code), product?.DesignId);
            if (woodBat) openConfigurationWindow(getCode(woodBat?.Code), product?.DesignId);
          }
        })
        .catch((error) => {
          throw error;
        });
    }
  };

  const items: MenuProps["items"] = [
    {
      label: (
        <Button type="text" onClick={viewOrEdit} className="rename-product-option">
          {viewEditLable}
        </Button>
      ),
      key: "view",
    },
    {
      label: (
        <Button type="text" onClick={handleDuplicateProduct} className="delete-product-option">
          Duplicate
        </Button>
      ),
      key: "duplicate",
    },
    {
      label: (
        <Button type="text" onClick={showRenameProductModal} className="rename-product-option">
          Rename
        </Button>
      ),
      key: "rename",
    },
    {
      label: (
        <Button type="text" onClick={showDeleteProductModal} className="delete-product-option">
          Delete
        </Button>
      ),
      key: "delete",
    },
  ];

  /* delete individual product item from hamburger menu list by confirming through modal */
  const deleteProduct = (): void => {
    const body: DeleteProductsBody = {
      Ids: `${product?.ZnodeMyLockerProductCustomizationDetailsId}`,
    };
    deleteProductService(body)
      .then(async (res) => {
        if (res && res?.data && res?.data?.IsSuccess === true) {
          notificationController.success({
            message: "Product item(s) deleted successfully",
          });
          if (product?.DesignType === "Artifi") {
            //TODO: remove static url from here
            const url = `${artifConfigurations?.Custom1}api/3/Design/DeleteDesign?websiteId=${artifConfigurations?.WebsiteCode}&webApiClientKey=${artifConfigurations?.WebApiclientKey}&userId=${userDetails?.id}&designId=${product?.DesignId}`;
            await deleteProductServiceFromArtifi(url);
            notificationController.success({
              message: "Product item deleted successfully",
            });
          }
          setIsDeleteModalVisible(false);
          getProductList(groupName);
        }
      })
      .catch((error) => {
        throw error;
      });
  };

  const renameProduct = (): void => {
    renameProductConfigurationNameService(
      product?.ZnodeMyLockerProductCustomizationDetailsId,
      renameProductName,
      renameGroupName.trim()
    )
      .then((res) => {
        if (res && res?.data) {
          cancelRenameProduct();
          getProductList("");
          setSelectedGroupName("");
          notificationController.success({
            message: "Product item renamed successfully",
          });
          setRefreshGroupNameFilterList(!refreshGroupNameFilterList);
        }
      })
      .catch((error: Error) => {
        throw error;
      });
  };

  const cancelRenameProduct = () => {
    setRenameProductName("");
    setRenameGroupName("");
    setIsRenameModalVisible(false);
  };

  const [dropdownOpen, setDropdownOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (dropdownOpen) {
        setDropdownOpen(false);
      }
    };

    // Add scroll event listener on mount
    window.addEventListener("wheel", handleScroll, { passive: true });

    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("wheel", handleScroll);
    };
  }, [dropdownOpen]);

  return (
    <>
      <Card className="product-grid collection-card-height">
        <Space direction={"vertical"} size={"small"} className="product-card">
          <Space className="card-action-selection">
            <Checkbox
              checked={isChecked}
              onChange={handleCheckboxChange}
              data-test-selector={"chkProductSelection"}
            />
            <Dropdown
              menu={{ items }}
              trigger={["click"]}
              open={dropdownOpen}
              onOpenChange={(open) => setDropdownOpen(open)}
              className="product-selection-action"
            >
              <a onClick={(e) => e.preventDefault()}>
                <MenuOutlined />
              </a>
            </Dropdown>
          </Space>
          <div className="product-image">
            <ProductImage
              imageUrl={`${imageUrl}&modifiedDate=${modifiedDate}`}
              imageHeight="100%"
              imageWidth="auto"
              isPreview={false}
              className="product-image"
              alt="altTextProductImage"
            />
          </div>
          <div className="product-name">
            <ProductTitle titleClass="product-name m-0" titleText={titleText} textFontLevel={5} />
          </div>
          <div className="product-id">
            <Text className="id-value">ID: {designId}</Text>
          </div>
          {leatherType && (
            <div className="product-id">
              <Text className="id-value">Series: {leatherType}</Text>
            </div>
          )}
        </Space>
      </Card>

      {isRenameModalVisible && (
        <RenameProductModal
          isRenameModalVisible={isRenameModalVisible}
          renameProduct={renameProduct}
          cancelRenameProduct={cancelRenameProduct}
          renameProductName={renameProductName}
          renameGroupName={renameGroupName}
          setRenameProductName={setRenameProductName}
          setRenameGroupName={setRenameGroupName}
        />
      )}

      <DeleteProductModal
        isDeleteModalVisible={isDeleteModalVisible}
        deleteProduct={deleteProduct}
        setIsDeleteModalVisible={() => setIsDeleteModalVisible(false)}
      />
      {showArtifiToDuplicate && (
        <ArtifiIntegration
          artifConfigurations={artifConfigurations}
          setShowComponent={setshowArtifiToDuplicate}
          ReorderMode={true}
          configurationId={configurationId}
        />
      )}
      {showArtifi && (
        <ArtifiIntegration
          artifConfigurations={artifConfigurations}
          setShowComponent={setshowArtifi}
          selectedRecord={product}
          EditMode={true}
          getProductList={getProductList}
          // pageIndex={pageIndex}
          // pageSize={pageSize}
          // categoryId={categoryId}
          // handleProductList={handleProductList}
        />
      )}
    </>
  );
};

export default MyCollectionCard;
